// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UQ-z","hovered":"VQ-z","hoverImage":"WQ-z","mainImage":"XQ-z","imageNoBackground":"YQ-z","fullSizeImage":"ZQ-z"};